import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";
import LoadingSpinner from "../Components/LoadingSpinner";
import Loader from "../Components/loader/Loader";

const ProtectedRoute = () => {
    const { authUser, loading, checkAuth, hasTriedAuth } = useAuthStore();

    const [checking, setChecking] = useState(true);
    const [localUser, setLocalUser] = useState(null);

    useEffect(() => {
        const verifyUser = async () => {
            console.log("verifyUser")

            if (!authUser && !hasTriedAuth) {
                console.log("Calling checkAuth from ProtectedRoute...");
                const data = await checkAuth();
                setLocalUser(data);
            } else {
                setLocalUser(authUser);
            }
            setChecking(false);
        };

        verifyUser();
    }, [authUser, checkAuth, hasTriedAuth]);

    // show loader while checking
    if (loading || checking) {
        return <Loader loading={true} />;
    }

    // decide with localUser instead of global Zustand state
    if (!localUser || localUser?.role !== "admin"|| authUser?.role!=="admin") {
        console.log("redirecting to login!");
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
